import API from 'utils/api';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'recaudacion/tipos-de-autoridades-determinantes-pae/';

/**
 * GET Tipos de Autoridades Determinantes
 * param {object} params
 * @returns {Promise<object>}
 */
export const getTiposDeAutoridadesDeterminantes = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Autoridad Determinante
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeAutoridadDeterminante = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Autoridad Determinante
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeAutoridadDeterminante = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Autoridad Determinante
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeAutoridadDeterminante = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Autoridad Determinante
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeAutoridadDeterminante = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
